<template>
  <!--  业务单位信息目录审批-->
  <div style="width: 100%;padding-top: 60px">
    <div style="position: fixed;top: 0;z-index: 999;width: 100%;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="show" v-if="inputForm.isDoTask">
          办理
        </van-button>
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="close">返回</van-button>
      </div>

      <div class="doTask" v-if="isshow">
        <div>
          <van-field name="radio" label="审批意见">
            <template #input>
              <van-radio-group v-model="auditForm.status" direction="horizontal">
                <van-radio name="同意">同意</van-radio>
                <van-radio name="不同意">不同意</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </div>
        <div>
          <van-cell-group>
            <van-field v-model="auditForm.message" rows="2" autosize label="审批说明" type="textarea"
                       placeholder="请输入审批说明"/>
          </van-cell-group>
        </div>
        <div style="text-align:center">
          <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="submitTask()">提交</van-button>
        </div>
      </div>
    </div>
    <van-collapse v-model="activeNames">
      <van-collapse-item title="业务单位信息" name="1">
        <van-field label="业务单位名称" v-model.trim="inputForm.corpName" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
        <van-field label="统一社会信用代码" v-model.trim="inputForm.creditCode" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
        <van-field label="联系人" v-model.trim="inputForm.contactName" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
        <van-field label="联系电话" v-model.trim="inputForm.phone" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
        <van-field label="邮箱" v-model.trim="inputForm.email" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
        <van-field label="开户行" v-model.trim="inputForm.depositBank" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
        <van-field label="银行账号" v-model.trim="inputForm.bankAccount" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
        <van-field label="经营范围" v-model="inputForm.businessScope" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
        <van-field label="通讯地址" v-model="inputForm.contactAddress" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
        <van-field label="备注" v-model="inputForm.remarks" label-width='100px' readonly input-align="left" :border="false" autosize rows="1" type="textarea"></van-field>
        <div style="padding-left: 16px;" v-show="inputForm.attachList.length > 0">
          <p>附件</p>
          <p style="display: block; color: #4caedc" v-for="(file,index) in inputForm.attachList" :key="index" @click="$viewAttach(file)">{{file.name}}</p>
        </div>
      </van-collapse-item>
<!--      <van-collapse-item title="附件信息" name="2" v-show="inputForm.attachList.length > 0">-->
<!--        <a style="display: block;" :key="index" v-for="(file,index) in inputForm.attachList"-->
<!--           :href="file.url">{{ file.name }}</a>-->
<!--      </van-collapse-item>-->
    </van-collapse>

    <process-record :procInsId="procInsId"></process-record>
  </div>
</template>

<script>
import TaskService from '@/api/flowable/TaskService.js'
import ProcessService from '@/api/flowable/ProcessService'
import {queryById, startFlow} from '../../api/base/wuyeBaseCorpInfo.js'
import processRecord from "../../components/processRecord/processRecord";
export default {
  name: "BusinessUnitInfo",
  data() {
    return {
      isshow: false,
      activeNames: ['1', '2'],
      inputForm: {
        id: '',
        corpName: '',
        creditCode: '',
        contactName: '',
        phone: '',
        email: '',
        depositBank: '',
        bankAccount: '',
        businessScope: '',
        contactAddress: '',
        remarks: '',
        attachIds: [],
        attachList: [],
        isDoTask: false,
        isLastTask: false,
      },
      auditForm: {
        message: '',
        type: '_flow_agree',
        status: '同意',
        userIds: null,
        assignee: null
      },
      taskId: '',
      taskDefKey: '',
      procInsId: '',
      procDefId: '',
      type: ''
    }
  },
  components: {
    processRecord
  },
  created() {
    let query = this.$route.query;
    let id = query.id
    this.taskId = query.taskId
    this.taskDefKey = query.taskDefKey
    this.procInsId = query.procInsId
    this.procDefId = query.procDefId
    this.type = query.type || ''
    this.init(id)
  },
  methods: {
    show() {
      this.isshow = !this.isshow
    },

    init(id) {
      queryById(id).then(({data}) => {
        this.inputForm = data
      }).catch(e => {
        console.log(e)
      })
    },
    close() {
      if(this.type !== '') {
        this.$router.back()
      } else {
        //Android、iOS支持PC不支持
        dd.biz.navigation.close({
          onSuccess: function (result) {
          },
          onFail: function (err) {
          }
        })
        // //Android、iOS不支持，PC支持
        dd.biz.navigation.quit({
          message: "quit message",
          onSuccess: function (result) {
          },
          onFail: function () {
          }
        })
      }
    },
    timestampToTime(timestamp) {
      let date = new Date(timestamp);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      return y + "-" + MM + "-" + d;// + " " + h + ":" + m + ":" + s;
    },
    submitTask() {
      if (this.auditForm.status === '同意') {
        this.agree()
      } else {
        this.reject()
      }
    },
    agree() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        let vars = {}
        vars = {...vars, ..._this.inputForm}
        // _this.auditForm.message = _this.inputForm.remarks
        _this.auditForm.type = _this.inputForm.isLastTask?'_flow_approval':'_flow_agree'
        new TaskService().audit({
          taskId: _this.taskId,
          taskDefKey: _this.taskDefKey,
          procInsId: _this.procInsId,
          procDefId: _this.procDefId,
          vars: vars,
          comment: _this.auditForm,
          assignee: _this.auditForm.assignee
        }).then(({data}) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          //更新数据库状态
          _this.inputForm.flowType = _this.inputForm.isLastTask ? 4 : 2;
          startFlow({
            id: _this.inputForm.id,
            flowType: _this.inputForm.flowType,
            formKey: _this.inputForm.formKey
          });

          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    },
    reject() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        new ProcessService().stop(_this.procInsId, _this.auditForm.message).then(({data}) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          //更新数据库状态
          _this.inputForm.flowType = 3;
          startFlow({
            id: _this.inputForm.id,
            flowType: _this.inputForm.flowType,
            formKey: _this.inputForm.formKey
          });

          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    }
  }
}
</script>

<style scoped>

</style>